import React from 'react'

import styles from './styles.scss'

const ShowMoreButton = count => {
  return <div className={styles.root}>и еще {count}</div>
}

export default ShowMoreButton
